import { ChangeDetectionStrategy, Component } from '@angular/core'
import { CentralizedButtonData } from './centralized-button.component.converter'
import { CmsBaseComponent } from '../cms-base-component/cms-base.component'

@Component({
  selector: 'mb-centralized-button',
  templateUrl: './centralized-button.component.html',
  styleUrls: ['./centralized-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CentralizedButtonComponent extends CmsBaseComponent<CentralizedButtonData> {
}

